import React, { useEffect, useRef } from "react";

// libraries
import { format } from "date-fns";

// context
import { useSendStation } from "../../../../../../context/SendStationContext";

// components
import { EmailField } from "./EmailField";
import { FormatSelector } from "./FormatSelector";

// styles
import * as styles from "./SendStationModalContent.module.css";

export const SendStationModalContent = () => {
  const { currentStation, emailEditable, reportFormat } = useSendStation();

  const inputRef = useRef(null);

  useEffect(() => {
    if (emailEditable && inputRef.current) {
      inputRef.current.focus();
    }
  }, [emailEditable]);

  if (!currentStation) {
    return null;
  }
  return (
    <>
      <p className={styles.subtitle}>
        {currentStation?.name || ""} Station{" "}
        <span className={styles.dot}>&#8226;</span> Today (
        {format(new Date(), "dd/MM/yyyy")})
      </p>

      <EmailField inputRef={inputRef} />

      <div className={styles.mainContentSection}>
        <div>
          <h4 className={styles.sectionTitle}>Report includes</h4>
          <ul className={styles.reportList}>
            <li>Total orders</li>
            <li>Average order time</li>
            <li>Orders list</li>
          </ul>
        </div>

        <FormatSelector />
      </div>

      <p className={styles.formatHint}>
        The report will be sent as {reportFormat.toUpperCase()} attachment
      </p>
    </>
  );
};
